export default "__VITE_ASSET__Cgy52Xtj__"